import { useLayoutEffect, useMemo, useRef } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
  buildManusThemeUrl,
  isManusThemeSlug,
  type ManusThemeSlug,
} from '@/constants/manusThemeEmbed'

/**
 * 与 DestinationEmbed 相同策略：about:blank + replace，减少 iframe 内导航占用父页历史栈。
 */
export default function ManusThemeEmbed() {
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const { pathname } = useLocation()
  const { i18n } = useTranslation()

  const segment = pathname.replace(/^\//, '').split('/')[0] ?? ''
  const safeSlug = isManusThemeSlug(segment) ? (segment as ManusThemeSlug) : null

  const targetUrl = useMemo(
    () => (safeSlug ? buildManusThemeUrl(safeSlug, i18n.language) : ''),
    [safeSlug, i18n.language],
  )

  useLayoutEffect(() => {
    if (!targetUrl) return
    const el = iframeRef.current
    const win = el?.contentWindow
    if (!win) return
    try {
      win.location.replace(targetUrl)
    } catch {
      el.src = targetUrl
    }
  }, [targetUrl])

  if (!safeSlug) {
    return <Navigate to="/" replace />
  }

  return (
    <iframe
      ref={iframeRef}
      src="about:blank"
      className="block w-full border-0"
      style={{ minHeight: 'calc(100vh - 4.5rem)', height: 'calc(100dvh - 4.5rem)' }}
      title={safeSlug}
      allowFullScreen
    />
  )
}
